import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { QueryFunction } from '@tanstack/react-query';

interface GetDocumentPageOCRDataResponse {
  ocrDatas: [OCRData[]];
  success: boolean;
}

export interface OCRData {
  id: string;
  pageId: string;
  engineType: string;
  ocr: WordData[];
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface WordData {
  bbox: {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
  };
  conf: number;
  value: string;
  new_line: boolean;
}

const getDocumentPageOCRData: QueryFunction<
  OCRData[],
  ['/document-page-ocr-data', string]
> = async ({ queryKey }) => {
  if (isMockServices())
    return (await mock(_mockDocumentPageData)).ocrDatas.flatMap((data) => data);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetDocumentPageOCRDataResponse>(
    `/ocr-data/documents/${queryKey[1]}`,
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data.ocrDatas.flatMap((data) => data);

  throw new Error('Failed to fetch document page OCR data');
};

export default getDocumentPageOCRData;

const _mockDocumentPageData = {
  ocrDatas: [
    {
      id: '1',
      pageId: '1',
      engineType: 'Tesseract',
      ocr: [
        {
          bbox: { x1: 10, x2: 50, y1: 20, y2: 40 },
          conf: 95,
          value: 'Sample Text',
          new_line: false,
        },
      ],
      isDeleted: false,
      createdAt: '2023-01-01T00:00:00Z',
      updatedAt: '2023-01-01T00:00:00Z',
    },
  ],
};
